import { render, staticRenderFns } from "./FormCard.vue?vue&type=template&id=703b4928&scoped=true&"
import script from "./FormCard.vue?vue&type=script&lang=ts&"
export * from "./FormCard.vue?vue&type=script&lang=ts&"
import style0 from "./FormCard.vue?vue&type=style&index=0&id=703b4928&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703b4928",
  null
  
)

export default component.exports